import { useDispatch, useSelector } from 'react-redux';
import {
  addTicketInsurance as addT,
  removeTicketInsurance as removeT,
  eneableTicketInsurance as eneableT,
  disableTicketInsurance as disableT,
  setTicketInsurancePrice as setTIPrice,
  activeAddOns as active,
  restoreTicketInsurance as restoreT,
  retore as disableAddons,
  setNotHealthy,
} from './addons.slice';

const useAddOns = () => {
  const dispatch = useDispatch();

  const addons = useSelector((state) => state.addons);

  const addOnsActive = !addons.ticketInsurance.disabled;

  const ticketInsurance = useSelector((state) => state.addons.ticketInsurance);

  const addTicketInsurance = () => {
    dispatch(addT());
  };

  const removeTicketInsurance = () => {
    dispatch(removeT());
  };

  const activeAddOns = (val) => {
    dispatch(active(val));
  };

  const eneableTicketInsurance = () => {
    dispatch(eneableT());
  };

  const disableTicketInsurance = () => {
    dispatch(disableT());
  };

  const setTicketInsuranceNotHealthy = () => {
    dispatch(setNotHealthy());
  };

  const restoreTicketInsurance = () => {
    dispatch(restoreT());
  };

  const disableAddOns = () => {
    dispatch(disableAddons());
  };

  const setTicketInsurancePrice = (price) => {
    dispatch(setTIPrice(price));
  };

  return {
    addOnsActive,
    ticketInsurance,
    activeAddOns,
    addTicketInsurance,
    removeTicketInsurance,
    eneableTicketInsurance,
    disableTicketInsurance,
    setTicketInsurancePrice,
    restoreTicketInsurance,
    setTicketInsuranceNotHealthy,
    disableAddOns,
  };
};

export default useAddOns;
